import { c as _c } from "react/compiler-runtime";
import type { RefObject } from "react";
import type { Suggestion } from "../types";
import { NftSuggestItem } from "./NftSuggestItem";
import { NftSuggestSentinel } from "./NftSuggestSentinel";
interface VirtualItem {
  index: number;
  start: number;
  size: number;
}
interface VirtualizationResult {
  virtualItems: VirtualItem[];
  totalHeight: number;
  sentinelRef: RefObject<HTMLDivElement | null>;
}
interface NftSuggestVirtualListProps {
  readonly items: Suggestion[];
  readonly virtualization: VirtualizationResult;
  readonly activeIndex: number;
  readonly listContainerRef: RefObject<HTMLDivElement | null>;
  readonly onHover: (index: number) => void;
  readonly onSelect: (item: Suggestion) => void;
}
export function NftSuggestVirtualList(t0) {
  const $ = _c(24);
  const {
    items,
    virtualization,
    activeIndex,
    listContainerRef,
    onHover,
    onSelect
  } = t0;
  const hasSuggestions = items.length > 0;
  let t1;
  if ($[0] !== virtualization.totalHeight) {
    t1 = {
      height: virtualization.totalHeight,
      position: "relative"
    };
    $[0] = virtualization.totalHeight;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "100%"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== activeIndex || $[4] !== hasSuggestions || $[5] !== items || $[6] !== onHover || $[7] !== onSelect || $[8] !== virtualization.sentinelRef || $[9] !== virtualization.virtualItems) {
    let t4;
    if ($[11] !== activeIndex || $[12] !== hasSuggestions || $[13] !== items || $[14] !== onHover || $[15] !== onSelect || $[16] !== virtualization.sentinelRef) {
      t4 = virtual => {
        if (virtual.index >= items.length) {
          return <NftSuggestSentinel key="suggestions-sentinel" top={virtual.start} height={virtual.size} sentinelRef={virtualization.sentinelRef} hasSuggestions={hasSuggestions} />;
        }
        const suggestion = items[virtual.index];
        const isActive = virtual.index === activeIndex;
        const isDisabled = suggestion?.tokenType !== "ERC721";
        if (!suggestion) {
          return null;
        }
        return <NftSuggestItem key={suggestion?.address} suggestion={suggestion} isActive={isActive} index={virtual.index} style={{
          top: virtual.start,
          height: virtual.size
        }} onHover={onHover} onSelect={onSelect} disabled={isDisabled} />;
      };
      $[11] = activeIndex;
      $[12] = hasSuggestions;
      $[13] = items;
      $[14] = onHover;
      $[15] = onSelect;
      $[16] = virtualization.sentinelRef;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    t3 = virtualization.virtualItems.map(t4);
    $[3] = activeIndex;
    $[4] = hasSuggestions;
    $[5] = items;
    $[6] = onHover;
    $[7] = onSelect;
    $[8] = virtualization.sentinelRef;
    $[9] = virtualization.virtualItems;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[18] !== t3) {
    t4 = <ul aria-hidden="true" className="tw-relative tw-m-0 tw-list-none tw-p-0" style={t2}>{t3}</ul>;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== listContainerRef || $[21] !== t1 || $[22] !== t4) {
    t5 = <div ref={listContainerRef} style={t1}>{t4}</div>;
    $[20] = listContainerRef;
    $[21] = t1;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  return t5;
}